import React, { useState } from 'react';
import { 
  Modal, 
  Form, 
  Button, 
  Container 
} from 'react-bootstrap';
import '../css/CreateQRCodeForm.css';

const CreateQRCodeForm = ({ show, onHide }) => {
  const [formData, setFormData] = useState({
    destination: '',
    title: '',
    enableShortLink: false,
    enableUTM: false,
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    onHide();
  };

  return (
    <Modal 
      show={show} 
      onHide={onHide}
      size="lg"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>Create a Code</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Container>
          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-4">
              <Form.Label>Destination</Form.Label>
              <Form.Control
                type="url"
                placeholder="https://example.com/my-long-url"
                value={formData.destination}
                onChange={(e) => setFormData({ ...formData, destination: e.target.value })}
                required
              />
            </Form.Group>

            <Form.Group className="mb-4">
              <Form.Label>Title (optional)</Form.Label>
              <Form.Control
                type="text"
                value={formData.title}
                onChange={(e) => setFormData({ ...formData, title: e.target.value })}
              />
            </Form.Group>

          </Form>
        </Container>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="light" onClick={onHide}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleSubmit}>
          Design your code
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CreateQRCodeForm; 